import { render, staticRenderFns } from "./SalesQuotations.vue?vue&type=template&id=5304fccd&scoped=true"
import script from "./SalesQuotations.vue?vue&type=script&lang=js"
export * from "./SalesQuotations.vue?vue&type=script&lang=js"
import style0 from "./SalesQuotations.vue?vue&type=style&index=0&id=5304fccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304fccd",
  null
  
)

export default component.exports